import React from "react";
import { BusETA } from "../api/buseta";
import { Header } from "./Header";

type BusETAListProps = {
  busETAs?: BusETA[];
};

const BusStopTable: React.FC<{ stopName: string; etas: BusETA[] }> = ({ stopName, etas }) => (
  <div className="stop-section">
    <h3 className="stop-section-name">{stopName}</h3>
    <table className="bus-eta-table">
      <thead>
        <tr>
          <th>Route</th>
          <th>Destination</th>
          <th>ETA</th>
        </tr>
      </thead>
      <tbody>
        {etas.map((eta, i) => (
          <tr key={i}>
            <td className="line-cell">{eta.routeID}</td>
            <td>{eta.directionText}</td>
            <td>{eta.minutes} min</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const BusETAList: React.FC<BusETAListProps> = ({ busETAs }) => {
  let content;
  if (busETAs === undefined) {
    content = <p>Loading...</p>;
  } else if (busETAs.length === 0) {
    content = <p>There are no buses to display.</p>;
  } else {
    const stops = busETAs.reduce<Record<string, { stopName: string; etas: BusETA[] }>>(
      (acc, eta) => {
        if (!acc[eta.stopID]) acc[eta.stopID] = { stopName: eta.stopName, etas: [] };
        acc[eta.stopID].etas.push(eta);
        return acc;
      },
      {},
    );
    content = Object.entries(stops).map(([stopID, { stopName, etas }]) => (
      <BusStopTable key={stopID} stopName={stopName} etas={etas} />
    ));
  }

  return (
    <>
      <Header>Bus ETAs</Header>
      {content}
    </>
  );
};
